import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Page from './Page';
import { Container } from "../styles/Container";
import { Heading } from "../styles/Heading";
import { Preamble } from "../styles/Preamble";
import { Button } from "../styles/Button";

const NotFoundPage = () => (
  <Page title="404" bgColor="#f2f2f2">
    <Container>
      <Heading big center>Sidan kunde inte hittas</Heading>
      <Preamble>
        Sidan du försökte besöka kunde inte hittas.
      </Preamble>
      <ButtonContainer>
      <Link to='/'>
        <BackButton>Tillbaka till startsidan</BackButton>
      </Link></ButtonContainer>
    </Container>
  </Page>
);

const ButtonContainer = styled.div`
  width: auto;
  display: block;
  margin: 120px auto;
  text-align: center;
`;

const BackButton = Button.extend`
  width: auto;
  display: inline-block;
`;

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js